import { memo } from 'react';
import { bool, string } from 'prop-types';

import { Section, Title } from '~/elements';

import styles from './TotalPriceDetails.scss';

const TotalPriceDetails = ({ totalPrice, isAppointmentGift }) => (
  <Section className={styles.TotalPriceDetails} data-testid="TotalPriceDetails">
    <Title className={styles.Title}>
      <span data-testid="TotalPriceDetailsTitle">Total price</span>
      <span data-testid="TotalPriceValue">{totalPrice}</span>
    </Title>
    {isAppointmentGift ? (
      <p data-testid="TotalPriceSubInfo">
        We will contact you to arrange payment before the appointment
      </p>
    ) : (
      <p data-testid="TotalPriceSubInfo">Payment will be taken on the day of the appointment</p>
    )}
  </Section>
);

TotalPriceDetails.propTypes = {
  totalPrice: string.isRequired,
  isAppointmentGift: bool.isRequired,
};

export const MemoizedTotalPriceDetails = memo(TotalPriceDetails);
